const busquedaEncontrada = {
  Title: '¡Encontramos {{total}} trabajos que pueden ser adecuados para ti!',
  'Ingresa tu email': 'Ingresa tu email',
}

export default busquedaEncontrada
